/* eslint-disable barrel-files/avoid-re-export-all -- FIXME: Fix this ESLint violation!, UXP-3757 - Remove barrels from web codebase */
import type Repository from '@src/service/worker/repository'

import { ContactService } from './contact'
import type { ConversationsEvent } from './conversation'
import { ConversationService } from './conversation'
import { EventService } from './event'
import { SearchService } from './search'

export type ServiceEvent = ConversationsEvent

export default class Service {
  contact: ContactService
  conversation: ConversationService
  search: SearchService
  event: EventService<ServiceEvent>

  constructor(repo: Repository) {
    this.event = new EventService()
    this.contact = new ContactService(repo.contact)
    this.conversation = new ConversationService(repo.conversation, this.event)
    this.search = new SearchService(repo.contact, repo.member)
  }

  invoke(name: string, method: string, query: any): Promise<any> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- FIXME: Fix this ESLint violation!
    const context = this[name]
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-function-type -- FIXME: Fix this ESLint violation!, FIXME: Fix this ESLint violation!
    const handler: Function = context?.[method]

    if (typeof handler !== 'function') {
      // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- FIXME: Fix this ESLint violation!
      return Promise.reject('handler not found')
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-argument -- FIXME: Fix this ESLint violation!
    return handler.call(context, ...query)
  }
}

export * from './base'
